import { i18n } from '@/locales';
const lc = 'views.hub_management.';
export const hubStatusTypeCodeObj = {
    ALL: 'ALL',
    /** 정상 */
    Y: 'Y',
    /** 정지 */
    S: 'S',
    /** 종료 */
    E: 'E',
    /** 사용요청 */
    P: 'P',
    /** 삭제 */
    N: 'N',
};
// 허브상태 타입(hubStatusType)
// 목록 : 전체/정상/정지/종료/사용요청
// 상세/수정 : 정상/정지/종료/사용요청
// https://www.notion.so/barogohq/useYn-f2da02fb6c394c02bc9a4b29c78719cd
export const hubStatusTypeCode = [
    hubStatusTypeCodeObj.ALL,
    hubStatusTypeCodeObj.Y,
    hubStatusTypeCodeObj.S,
    hubStatusTypeCodeObj.E,
    hubStatusTypeCodeObj.P,
    hubStatusTypeCodeObj.N,
];
const imgIconCodeList = {
    ALL: '',
    Y: 'ok',
    S: 'stop',
    E: 'leave',
    P: 'register-request',
    N: '',
};
export default hubStatusTypeCode.map((code, index) => ({
    text: i18n.t(`${lc}status_code_type_list[${index}]`),
    value: code,
    field: 'useYn',
    imgIcon: imgIconCodeList[code],
}));
